import { envVars } from '@/config';
import { appConfigData } from '@/mocks';
import type {
  IGetAppConfigReq,
  IGetAppConfigRes,
  IGetAppScreensaverReq,
  IGetAppScreensaverRes,
  IGetSettingsReq,
  IGetSettingsRes,
  IScreenSaver,
} from '@/types';
import { createApi } from '@reduxjs/toolkit/query/react';
import { fetchCustomBaseQuery } from '../fetcher';
import { setAppConfig, setGlobalLoading } from './slice';

export const globalApi = createApi({
  reducerPath: 'globalApi',
  baseQuery: fetchCustomBaseQuery({
    baseUrl: envVars.backendUrl,
    mock: false,
  }),
  tagTypes: ['global'],
  endpoints: (builder) => ({
    getConfig: builder.query<IGetAppConfigRes, IGetAppConfigReq>({
      query: () => ({
        url: '/config',
        isProtected: false,
        forceMock: true,
        mockData: {
          message: 'Config fetched Successfully',
          data: appConfigData,
        },
      }),
      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        const { data } = await queryFulfilled;
        dispatch(setGlobalLoading(false));
        dispatch(setAppConfig(data.data));
      },
    }),
    getScreenSaver: builder.query<IScreenSaver, IGetAppScreensaverReq>({
      query: () => ({
        url: '/cups-and-fpf/screensaver',
        isProtected: false,
      }),
      transformResponse: (response: IGetAppScreensaverRes) => response.data?.screensaver ?? null,
    }),
    getSettings: builder.query<IGetSettingsRes['data']['settings'], IGetSettingsReq>({
      query: () => ({
        url: '/cups-and-fpf/settings',
        isProtected: false,
      }),
      transformResponse: (response: IGetSettingsRes) => {
        return {
          ...response.data?.settings,
          LOGO: { path: '/homepage/logo-cup.png', caption: '', mime_type: 'image/png' },
          SECONDARY_LOGO: { path: '/homepage/logo-history.png', caption: '', mime_type: 'image/png' },
        };
      },
    }),
  }),
});

export const { useGetConfigQuery, useGetScreenSaverQuery } = globalApi;
